// source: v2/site_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var v2_types_utility_pb = require('../v2/types/utility_pb.js');
goog.object.extend(proto, v2_types_utility_pb);
var v2_types_pagination_pb = require('../v2/types/pagination_pb.js');
goog.object.extend(proto, v2_types_pagination_pb);
var v2_types_site_pb = require('../v2/types/site_pb.js');
goog.object.extend(proto, v2_types_site_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.CreateSiteRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.CreateSiteResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetSiteFiltersRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetSiteFiltersResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetSiteRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetSiteResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ListSitesRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ListSitesResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UpdateSiteRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UpdateSiteResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.CreateSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.CreateSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.CreateSiteRequest.displayName = 'proto.loopup.ctgateway.v2.CreateSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.CreateSiteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.CreateSiteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.CreateSiteResponse.displayName = 'proto.loopup.ctgateway.v2.CreateSiteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetSiteRequest.displayName = 'proto.loopup.ctgateway.v2.GetSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetSiteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetSiteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetSiteResponse.displayName = 'proto.loopup.ctgateway.v2.GetSiteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.ListSitesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.ListSitesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.ListSitesRequest.displayName = 'proto.loopup.ctgateway.v2.ListSitesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.ListSitesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.ListSitesResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.ListSitesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.ListSitesResponse.displayName = 'proto.loopup.ctgateway.v2.ListSitesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.UpdateSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.UpdateSiteRequest.displayName = 'proto.loopup.ctgateway.v2.UpdateSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.UpdateSiteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.UpdateSiteResponse.displayName = 'proto.loopup.ctgateway.v2.UpdateSiteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetSiteFiltersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetSiteFiltersRequest.displayName = 'proto.loopup.ctgateway.v2.GetSiteFiltersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetSiteFiltersResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetSiteFiltersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetSiteFiltersResponse.displayName = 'proto.loopup.ctgateway.v2.GetSiteFiltersResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.CreateSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.CreateSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    customerId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    address1: (f = msg.getAddress1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address2: (f = msg.getAddress2()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    stateProvince: (f = msg.getStateProvince()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    zipPostalCode: (f = msg.getZipPostalCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    countryCode: jspb.Message.getFieldWithDefault(msg, 8, ""),
    emergencyAddress1: (f = msg.getEmergencyAddress1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    emergencyAddress2: (f = msg.getEmergencyAddress2()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    emergencyCity: (f = msg.getEmergencyCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    emergencyStateProvince: (f = msg.getEmergencyStateProvince()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    emergencyZipPostalCode: (f = msg.getEmergencyZipPostalCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    emergencyCountryCode: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.CreateSiteRequest;
  return proto.loopup.ctgateway.v2.CreateSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.CreateSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress1(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress2(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStateProvince(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setZipPostalCode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmergencyAddress1(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmergencyAddress2(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmergencyCity(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmergencyStateProvince(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmergencyZipPostalCode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmergencyCountryCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.CreateSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.CreateSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress1();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress2();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStateProvince();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getZipPostalCode();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEmergencyAddress1();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyAddress2();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyCity();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyStateProvince();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyZipPostalCode();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyCountryCode();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string customer_id = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue address_1 = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getAddress1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setAddress1 = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearAddress1 = function() {
  return this.setAddress1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasAddress1 = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue address_2 = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getAddress2 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setAddress2 = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearAddress2 = function() {
  return this.setAddress2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasAddress2 = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue city = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasCity = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue state_province = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getStateProvince = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setStateProvince = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearStateProvince = function() {
  return this.setStateProvince(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasStateProvince = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue zip_postal_code = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getZipPostalCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setZipPostalCode = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearZipPostalCode = function() {
  return this.setZipPostalCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasZipPostalCode = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string country_code = 8;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.StringValue emergency_address_1 = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getEmergencyAddress1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setEmergencyAddress1 = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearEmergencyAddress1 = function() {
  return this.setEmergencyAddress1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasEmergencyAddress1 = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue emergency_address_2 = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getEmergencyAddress2 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setEmergencyAddress2 = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearEmergencyAddress2 = function() {
  return this.setEmergencyAddress2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasEmergencyAddress2 = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue emergency_city = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getEmergencyCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setEmergencyCity = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearEmergencyCity = function() {
  return this.setEmergencyCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasEmergencyCity = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue emergency_state_province = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getEmergencyStateProvince = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setEmergencyStateProvince = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearEmergencyStateProvince = function() {
  return this.setEmergencyStateProvince(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasEmergencyStateProvince = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue emergency_zip_postal_code = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getEmergencyZipPostalCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setEmergencyZipPostalCode = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.clearEmergencyZipPostalCode = function() {
  return this.setEmergencyZipPostalCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.hasEmergencyZipPostalCode = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string emergency_country_code = 14;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.getEmergencyCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteRequest.prototype.setEmergencyCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.CreateSiteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.CreateSiteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.CreateSiteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CreateSiteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && v2_types_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteResponse}
 */
proto.loopup.ctgateway.v2.CreateSiteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.CreateSiteResponse;
  return proto.loopup.ctgateway.v2.CreateSiteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.CreateSiteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteResponse}
 */
proto.loopup.ctgateway.v2.CreateSiteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_site_pb.Site;
      reader.readMessage(value,v2_types_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.CreateSiteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.CreateSiteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.CreateSiteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CreateSiteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.loopup.ctgateway.v2.Site}
 */
proto.loopup.ctgateway.v2.CreateSiteResponse.prototype.getSite = function() {
  return /** @type{?proto.loopup.ctgateway.v2.Site} */ (
    jspb.Message.getWrapperField(this, v2_types_site_pb.Site, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.Site|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CreateSiteResponse} returns this
*/
proto.loopup.ctgateway.v2.CreateSiteResponse.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CreateSiteResponse} returns this
 */
proto.loopup.ctgateway.v2.CreateSiteResponse.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateSiteResponse.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetSiteRequest}
 */
proto.loopup.ctgateway.v2.GetSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetSiteRequest;
  return proto.loopup.ctgateway.v2.GetSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetSiteRequest}
 */
proto.loopup.ctgateway.v2.GetSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetSiteRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.GetSiteRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetSiteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetSiteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetSiteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetSiteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && v2_types_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetSiteResponse}
 */
proto.loopup.ctgateway.v2.GetSiteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetSiteResponse;
  return proto.loopup.ctgateway.v2.GetSiteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetSiteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetSiteResponse}
 */
proto.loopup.ctgateway.v2.GetSiteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_site_pb.Site;
      reader.readMessage(value,v2_types_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetSiteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetSiteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetSiteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetSiteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.loopup.ctgateway.v2.Site}
 */
proto.loopup.ctgateway.v2.GetSiteResponse.prototype.getSite = function() {
  return /** @type{?proto.loopup.ctgateway.v2.Site} */ (
    jspb.Message.getWrapperField(this, v2_types_site_pb.Site, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.Site|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetSiteResponse} returns this
*/
proto.loopup.ctgateway.v2.GetSiteResponse.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetSiteResponse} returns this
 */
proto.loopup.ctgateway.v2.GetSiteResponse.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetSiteResponse.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.ListSitesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.ListSitesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ListSitesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    countryCode: (f = msg.getCountryCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 6, 0),
    sortBy: jspb.Message.getFieldWithDefault(msg, 7, 0),
    sortDirection: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.ListSitesRequest;
  return proto.loopup.ctgateway.v2.ListSitesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.ListSitesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryCode(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 7:
      var value = /** @type {!proto.loopup.ctgateway.v2.SiteSortProperty} */ (reader.readEnum());
      msg.setSortBy(value);
      break;
    case 8:
      var value = /** @type {!proto.loopup.ctgateway.v2.SortDirection} */ (reader.readEnum());
      msg.setSortDirection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.ListSitesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.ListSitesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ListSitesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSortBy();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSortDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue customer_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
*/
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue country_code = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.getCountryCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
*/
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.clearCountryCode = function() {
  return this.setCountryCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue city = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
*/
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.hasCity = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue name = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
*/
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 page_number = 5;
 * @return {number}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 page_size = 6;
 * @return {number}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional SiteSortProperty sort_by = 7;
 * @return {!proto.loopup.ctgateway.v2.SiteSortProperty}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.getSortBy = function() {
  return /** @type {!proto.loopup.ctgateway.v2.SiteSortProperty} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.SiteSortProperty} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional SortDirection sort_direction = 8;
 * @return {!proto.loopup.ctgateway.v2.SortDirection}
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.getSortDirection = function() {
  return /** @type {!proto.loopup.ctgateway.v2.SortDirection} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.SortDirection} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesRequest} returns this
 */
proto.loopup.ctgateway.v2.ListSitesRequest.prototype.setSortDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.ListSitesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.ListSitesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.ListSitesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ListSitesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sitesList: jspb.Message.toObjectList(msg.getSitesList(),
    v2_types_site_pb.Site.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v2_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.ListSitesResponse}
 */
proto.loopup.ctgateway.v2.ListSitesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.ListSitesResponse;
  return proto.loopup.ctgateway.v2.ListSitesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.ListSitesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.ListSitesResponse}
 */
proto.loopup.ctgateway.v2.ListSitesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_site_pb.Site;
      reader.readMessage(value,v2_types_site_pb.Site.deserializeBinaryFromReader);
      msg.addSites(value);
      break;
    case 2:
      var value = new v2_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v2_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.ListSitesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.ListSitesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ListSitesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_site_pb.Site.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v2_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Site sites = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.Site>}
 */
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.getSitesList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.Site>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_site_pb.Site, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.Site>} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesResponse} returns this
*/
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.setSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.Site=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.Site}
 */
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.addSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.Site, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.ListSitesResponse} returns this
 */
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.clearSitesList = function() {
  return this.setSitesList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v2.PaginationInfo}
 */
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v2.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v2_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v2.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ListSitesResponse} returns this
*/
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ListSitesResponse} returns this
 */
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ListSitesResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.UpdateSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.UpdateSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: (f = msg.getName()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    address1: (f = msg.getAddress1()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    address2: (f = msg.getAddress2()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    city: (f = msg.getCity()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    stateProvince: (f = msg.getStateProvince()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    zipPostalCode: (f = msg.getZipPostalCode()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    emergencyAddress1: (f = msg.getEmergencyAddress1()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    emergencyAddress2: (f = msg.getEmergencyAddress2()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    emergencyCity: (f = msg.getEmergencyCity()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    emergencyStateProvince: (f = msg.getEmergencyStateProvince()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    emergencyZipPostalCode: (f = msg.getEmergencyZipPostalCode()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.UpdateSiteRequest;
  return proto.loopup.ctgateway.v2.UpdateSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.UpdateSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 3:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setAddress1(value);
      break;
    case 4:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setAddress2(value);
      break;
    case 5:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 6:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setStateProvince(value);
      break;
    case 7:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setZipPostalCode(value);
      break;
    case 8:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setEmergencyAddress1(value);
      break;
    case 9:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setEmergencyAddress2(value);
      break;
    case 10:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setEmergencyCity(value);
      break;
    case 11:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setEmergencyStateProvince(value);
      break;
    case 12:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setEmergencyZipPostalCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.UpdateSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.UpdateSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getAddress1();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getAddress2();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getStateProvince();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getZipPostalCode();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyAddress1();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyAddress2();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyCity();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyStateProvince();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyZipPostalCode();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NullableString name = 2;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getName = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NullableString address_1 = 3;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getAddress1 = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 3));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setAddress1 = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearAddress1 = function() {
  return this.setAddress1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasAddress1 = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional NullableString address_2 = 4;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getAddress2 = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 4));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setAddress2 = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearAddress2 = function() {
  return this.setAddress2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasAddress2 = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional NullableString city = 5;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getCity = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 5));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasCity = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NullableString state_province = 6;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getStateProvince = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 6));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setStateProvince = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearStateProvince = function() {
  return this.setStateProvince(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasStateProvince = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional NullableString zip_postal_code = 7;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getZipPostalCode = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 7));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setZipPostalCode = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearZipPostalCode = function() {
  return this.setZipPostalCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasZipPostalCode = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional NullableString emergency_address_1 = 8;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getEmergencyAddress1 = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 8));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setEmergencyAddress1 = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearEmergencyAddress1 = function() {
  return this.setEmergencyAddress1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasEmergencyAddress1 = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional NullableString emergency_address_2 = 9;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getEmergencyAddress2 = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 9));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setEmergencyAddress2 = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearEmergencyAddress2 = function() {
  return this.setEmergencyAddress2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasEmergencyAddress2 = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional NullableString emergency_city = 10;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getEmergencyCity = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 10));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setEmergencyCity = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearEmergencyCity = function() {
  return this.setEmergencyCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasEmergencyCity = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional NullableString emergency_state_province = 11;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getEmergencyStateProvince = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 11));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setEmergencyStateProvince = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearEmergencyStateProvince = function() {
  return this.setEmergencyStateProvince(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasEmergencyStateProvince = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional NullableString emergency_zip_postal_code = 12;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.getEmergencyZipPostalCode = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 12));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.setEmergencyZipPostalCode = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.clearEmergencyZipPostalCode = function() {
  return this.setEmergencyZipPostalCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteRequest.prototype.hasEmergencyZipPostalCode = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.UpdateSiteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.UpdateSiteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && v2_types_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteResponse}
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.UpdateSiteResponse;
  return proto.loopup.ctgateway.v2.UpdateSiteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.UpdateSiteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteResponse}
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_site_pb.Site;
      reader.readMessage(value,v2_types_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.UpdateSiteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.UpdateSiteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.loopup.ctgateway.v2.Site}
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse.prototype.getSite = function() {
  return /** @type{?proto.loopup.ctgateway.v2.Site} */ (
    jspb.Message.getWrapperField(this, v2_types_site_pb.Site, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.Site|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteResponse} returns this
*/
proto.loopup.ctgateway.v2.UpdateSiteResponse.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateSiteResponse} returns this
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateSiteResponse.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetSiteFiltersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetSiteFiltersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersRequest}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetSiteFiltersRequest;
  return proto.loopup.ctgateway.v2.GetSiteFiltersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetSiteFiltersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersRequest}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetSiteFiltersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetSiteFiltersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue customer_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersRequest} returns this
*/
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersRequest.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetSiteFiltersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    countriesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    citiesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetSiteFiltersResponse;
  return proto.loopup.ctgateway.v2.GetSiteFiltersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addCountries(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetSiteFiltersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getCitiesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string countries = 1;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.getCountriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.setCountriesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.addCountries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.clearCountriesList = function() {
  return this.setCountriesList([]);
};


/**
 * repeated string cities = 2;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.getCitiesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.setCitiesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.addCities = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetSiteFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetSiteFiltersResponse.prototype.clearCitiesList = function() {
  return this.setCitiesList([]);
};


goog.object.extend(exports, proto.loopup.ctgateway.v2);
